module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.loggedIn) { 
    ; __append(" <a class=\"btn btn-primary ml-md-2\" href=\"/account/shipments\">Dashboard</a> ")
    ;  } else { 
    ; __append(" <a href=\"/signup\" class=\"btn btn-secondary mx-md-2 my-3 my-md-0\">Sign Up</a> <a href=\"/signin\" class=\"btn btn-outline-secondary mb-3 mb-md-0\">Log In</a> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/basic_navbar.ejs
// module id = 1876
// module chunks = 1